(function () {
	"use strict";
	angular.module("cardFrontConsumer.areas.enterPin", []);
}());